import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IrisFillLoaderComponent } from './fill-loader.component';

@NgModule({
  imports: [
    CommonModule,
  ],
  declarations: [
    IrisFillLoaderComponent,
  ],
  exports: [
    IrisFillLoaderComponent,
  ],
})
export class IrisFillLoaderComponentModule { }
